<template>
  <v-sheet
    class="px-2 text-caption font-weight-regular my-1"
    :class="classes"
    rounded="lg"
    outlined
  >
    <slot />
  </v-sheet>
</template>

<script>
export default {
  computed: {
    classes() {
      return {
        "blue lighten-5 blue--text text--darken-3": this.status === "plate",
        "green lighten-5 green--text text--darken-3": this.status === "new",
        "purple lighten-5 purple--text text--darken-3": this.status === "coming",
      }
    },
    status() {
      const _status = this.$slots.default[0].text.toLowerCase()
      const plate = ["plate", "number", "ស្លាក", "លេខ", "កម្ពុជា"]
      if (plate.some((each) => _status.includes(each))) {
        return "plate"
      }
      const coming = ["coming", "soon", "on the way", "នឹង", "មក", "ដល់"]
      if (coming.some((each) => _status.includes(each))) {
        return "coming"
      }
      return "new"
    },
  },
}
</script>
